import actions from './moduleAudioPlayerActions';
import getters from './moduleAudioPlayerGetters';
import mutations from './moduleAudioPlayerMutations';
import state from './moduleAudioPlayerState';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
